<template>
  <div class="list shad">
    <div v-if="user == null" style="height:100%">
      <b-spinner></b-spinner>
    </div>
    <div v-else>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div>
          <!-- Pub: {{ publish }} -->
          <share-bar 
            v-if="published && publish" 
            :shareUrl="getPublicLink"
            :twitterShareMessage="title + ', a recipe by ' + username + ' on @CulinaryApp @Blockstack'"
            ></share-bar>
        </div>
        <div></div>
        <!-- <div class="btn-group" role="group" style="float:right" aria-label="Basic example">
          <button type="button" class="btn" :class="{ 'btn-secondary': type === 'bullet' }" @click="setType('bullet')"><strong><em><font-awesome-icon :icon="['far', 'list-ul']" /></em></strong></button>
          <button type="button" class="btn" :class="{ 'btn-secondary': type === 'ordered' }" @click="setType('ordered')"><font-awesome-icon :icon="['far', 'list-ol']" /></button>
        </div> -->
        <div style="text-align:right">
          <b-form-checkbox v-model="publish" name="check-button" switch>
            Publish
          </b-form-checkbox>
          <div v-if="published">
            <!-- <a :href="getPublicLink" target="_blank">Public Link</a> -->
            <b-link :to="'../shared/' + username + '/' + publicId" target="_blank">Public Link</b-link>
          </div>
          <!-- <div v-else>Not pub</div> -->
        </div>
      </div>
      <hr class="mb-4 mt-4" />
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;font-family:'Indie Flower',cursive" class="mb-2">
        <editable-title 
          v-model.trim="title"
          style="width:100%"
          >
        </editable-title>
      </div>
      <!-- <hr /> -->
      <!-- <h4>Summary</h4> -->
      <b-textarea 
        style="width:100%;min-height:100px;border:1px solid whitesmoke"
        placeholder="Recipe summary..."
        v-model="summary"
      ></b-textarea>
      <!-- <b-card class="mb-5" no-body>
        <b-card-header>Summary</b-card-header>
        <b-container fluid style="">
          <b-textarea 
            no-auto-shrink
            placeholder="Enter description..."
            style="width:100%;border: 0px;margin-top:10px;margin-bottom:10px"></b-textarea>
        </b-container>
      </b-card> -->
      <!-- <hr /> -->
      <h3 class="mt-4 mb-4">Ingredients</h3>
      <!-- <ag-grid-vue style="width: 100%; height: 500px;"
        class="ag-theme-balham"
        :columnDefs="columnDefs"
        :rowData="rowData">
      </ag-grid-vue> -->
      <!-- <ol v-if="type==='ordered'">
        <li v-for="(item, index) in items" :key="item.id" class="m-2">
          <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center">
            <single-line-input 
              :value="item.value" 
              :index="index"
              :active="item.editState === 'focus'"
              @input="updateItem(index, $event)"
              @item-focus="setItemFocus(index)"
              @item-blur="setItemBlur(index)"
              style="width:100%"
            ></single-line-input>
            <transition name="fade">
            <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="item.editState === 'focus'">
              <font-awesome-icon 
                :icon="['far', 'minus-circle']" 
                style="font-size:30;cursor:pointer" 
              />
            </button>
            </transition>
          </div>
        </li>
      </ol> -->
      <ul>
        <li v-for="(item, index) in items" :key="item.id" class="m-2">
          <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center">
            <single-line-input 
              :value="item.value" 
              :index="index"
              @input="updateItem(index, $event)"
              @item-focus="setItemFocus(index)"
              @item-blur="setItemBlur(index)"
              @delete-item="deleteItem(index)"
              style="width:100%"
            ></single-line-input>
            <transition name="fade">
            <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="item.editState === 'focus'">
              <font-awesome-icon 
                :icon="['far', 'minus-circle']" 
                style="font-size:30;cursor:pointer" 
              />
            </button>
            </transition>
          </div>
        </li>
      </ul>

      <!-- <div v-for="(item, index) in items" :key="item.id" class="mb-4">
        <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center">
          <code-editor 
            :value="item.value" 
            :index="index"
            @input="updateItem(index, $event)"
            @item-focus="setItemFocus(index)"
            @item-blur="setItemBlur(index)"
            @delete-item="deleteItem(index)"
            style="width:100%"
          ></code-editor>
          <transition name="fade">
          <button @click.prevent="deleteItem(index)" class="deletebutton" v-show="item.editState === 'focus'">
            <font-awesome-icon 
              :icon="['far', 'minus-circle']" 
              style="font-size:30;cursor:pointer" 
            />
          </button>
          </transition>
        </div>
      </div> -->
      <!-- </ul> -->
      <b-container class="mt-4 mb-4">
        <b-row>
          <b-col><div class="mb-2 p-2 addbutton"  @click="addNewItem"><font-awesome-icon :icon="['far', 'plus-circle']" style="font-size:30" /></div></b-col>
        </b-row>
      </b-container>
      <!-- <hr /> -->
      <h3>Instructions</h3>
      
      <div class="notebox" style="">
        <note-editor :value="{ noteId: id, note: note}" @input="updateNote($event)" />
      </div>
      <!-- <div class="mt-5">
          <pre>{{ listData }}</pre>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex'
import NoteEditor from '@/components/NoteEditor'
import EditableTitle from '@/components/EditableTitle'
import SingleLineInput from '@/components/SingleLineInput'
import { Person } from "blockstack";
import { userSession } from "../userSession";
import { EventBus } from '@/event-bus';
import store from '@/store/store'
import NProgress from 'nprogress'
import { setTimeout } from 'timers';
// import CodeEditor from '@/components/CodeEditor'
// import { AgGridVue } from "ag-grid-vue";
import ShareBar from '@/components/ShareBar'

export default {
  data() {
    return {
      columnDefs: null,
      rowData: null,
    }
  },
  computed: {
    ...mapFields([
      'listData',
      'listData.id',
      'listData.title',
      'listData.summary',
      'listData.type',
      'listData.showNote',
      'listData.note',
      'listData.createdAt',
      'listData.publish',
      'listData.publicId',
      'listData.published',
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
    ...mapMultiRowFields(['listData.items']),
    ...mapGetters(['listsCount']),
    needsSave () {
      return this.$store.getters.needsSave
    },
    needsSave_currentList () {
      return this.$store.getters.needsSave_currentList
    },
    needsSave_lists () {
      return this.$store.getters.needsSave_lists
    },
    getPublicLink () {
      let link = "https://culinary.cabinetapps.com/shared/" + this.username + "/" + this.publicId
      return link
    }
  },
  created() {

    this.$store.dispatch('setUserSession')
    EventBus.$on('new-clicked', this.new);
    EventBus.$on('save-clicked', this.save);
    EventBus.$on('print-clicked', this.print);
    // EventBus.$on('menu-clicked', this.showNewNote);
    EventBus.$on('delete-clicked', this.delete);
    EventBus.$on('switch-list', this.switchList);
  },
  mounted() {
    // console.log("[List] mounted - checking for blockstack")
    // this.$store.dispatch('checkAndFinishSignIn')

    if (this.userSession.isUserSignedIn()) {
      // console.log("user is signed in");
      this.$store.dispatch('setUserProperties').then(() => {
        this.$store.dispatch('loadLists')
      })
      
    } else if (userSession.isSignInPending()) {
      // console.log("signinpending")
      this.userSession.handlePendingSignIn().then(userData => {
        // console.log("user pending log in finished");
        this.$store.dispatch('loadLists')
        window.location = window.location.origin
      });
    } else {
      // console.log("No user signed in")
      this.$router.push('/login')
    }

    // console.log("[List] mounted, with param: ", this.$route.params.id);
    // console.log('enabling toolbar')
    this.$store.commit('SET_ENABLETOOLBAR', true)

    // Fix Safari UI bug
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      setTimeout(this.safariUIFix, 10);
    }
  },
  methods: {
    addNewItem() {
      this.$store.commit('ADD_NEW_ITEM')
    },
    updateItem(index, newValue) {
      this.$store.commit('UPDATE_ITEM', { index, newValue })
      // this.$store.dispatch('saveIfNeeded')
    },
    updateNote(newValue) {
      if (this.note != newValue) {
        this.$store.commit('UPDATE_NOTE', newValue)
      }
    },
    updateCode(newValue) {
      console.log('got update code')
      // if (this.code != newValue) {
      //   // this.$store.commit('UPDATE_CODE', newValue)
      // }
    },
    setItemFocus(index) {
      this.$store.commit('SET_ITEM_FOCUS', index)
    },
    setItemBlur(index) {
      this.$store.commit('SET_ITEM_BLUR', index)
    },
    deleteItem(index) {
      this.$store.commit('DELETE_ITEM', index)
    },
    new () {
      this.$router.push('/new').catch(err => {})
    },
    save () {
      // console.log('running save')
      this.$store.commit('SET_LIST_SAVING', true)
      NProgress.start()
      var listId = this.id
      var isNewList = this.createdAt === null
      this.$store.dispatch('save')
        .then(() => {
          if (isNewList) {
            this.$router.push('/recipes/' + listId)
          } else {
            // console.log('not new list, continue...')
          }
        })
        .finally(() => {
          this.$store.commit('SET_LIST_SAVING', false)
          NProgress.done()
        })
    },
    print () {
      window.print()
      // console.log('needsSave is :', this.$store.getters.needsSave)
      // console.log('needsSave_currentList is :', this.$store.getters.needsSave_currentList)
      // console.log('needsSave_lists: ', this.$store.getters.needsSave_lists)
    },
    delete () {
      console.log('delete')
      // alert('delete coming soon!')
      this.$store.commit('SET_LIST_DELETING', true)
      this.$store.dispatch('deleteCurrentList')
        .then(() => {
          // this route will generate a new list if necessary
          this.$store.commit('SET_LIST_DELETING', false)
          this.$router.push('/recipes')
        })
        .catch(() => {
          this.$store.commit('SET_LIST_DELETING', false)
        })
    },
    switchList (listIndex) {
      const listId = this.$store.state.lists[listIndex].id
      this.$router.push('/recipes/' + listId).catch(err => {})
    },
    setType(listType) {
      this.type=listType
      if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        setTimeout(this.safariUIFix, 10)
      }
    },
    safariUIFix() {
      this.addNewItem()

      this.$nextTick(() => {
        // console.log('deleting on next tick...')
        let index = this.items.length - 1
        if (this.items[index].value === "") {
          this.deleteItem(index)
        }
      })
    }
  },
  beforeMount() {
    this.columnDefs = [
      {headerName: 'Ingredient', field: 'ingredient', sortable: true, editable: true},
      {headerName: 'Amount', field: 'amount', sortable: true, editable: true},
    ];

    this.rowData = [
      {}, {}, {}
    ];
  },
  beforeRouteEnter (routeTo, routeFrom, next) {
    // console.log('BEFORE ROUTE ENTER')
    // store.commit('SET_SHOWTOOLBAR', true)
    const userSession = store.state.blockstack.userSession
    if (userSession) {
      if (!store.state.blockstack.userSession.isUserSignedIn()) {
        console.log('user not signed in')
        next({
          path: '/'
        })
        return
      }
    } else {
      next('/')
      return
    }

    if (!routeTo.params.id) {
      next() // Handle case for new list
      return
    }

    // Load existing list
    store.dispatch('loadLists')
    store.dispatch('loadList', routeTo.params.id)
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        if (listData != null) {
          next()
          return
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })
  },
  beforeRouteUpdate (routeTo, routeFrom, next) {

    const userSession = store.state.blockstack.userSession
    if (userSession) {
      if (!store.state.blockstack.userSession.isUserSignedIn()) {
        console.log('user not signed in')
        next({
          path: '/'
        })
        return
      }
    } else {
      next('/')
      return
    }

    store.dispatch('loadLists')
    store.dispatch('loadList', routeTo.params.id)
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        if (listData != null) {
          next()
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })
  },
  // beforeRouteLeave (routeTo, routeFrom, next) {
  //   console.log('BEFORE ROUTE LEAVE')
  //   store.commit('SET_SHOWTOOLBAR', false)
  //   next()
  // },
  components: {
    NoteEditor,
    EditableTitle,
    SingleLineInput,
    // CodeEditor,
    ShareBar
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Lexend+Deca&display=swap');
@import url('https://fonts.googleapis.com/css?family=Mansalva&display=swap');
@import url('https://fonts.googleapis.com/css?family=Indie+Flower&display=swap');

h1 {
  /* font-family: 'Lexend Deca', sans-serif; */
}

h3 {
  font-family: 'Indie Flower', cursive;
}


.list {
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  /* margin: 8px */
  margin-left: 5px;
  margin-right: 8px;
}

.shad {
  -webkit-box-shadow: 6px 6px 5px black;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow:    6px 6px 5px black;  /* Firefox 3.5 - 3.6 */
  box-shadow:         6px 6px 5px black;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

li {
  font-size:22px;
}
li div {
  font-size:22px;
  /* font-weight:450; */
  /* font-family: 'Lexend Deca', sans-serif; */
}

.listitem {
  /* border: 1px dotted gray; */
}

.addbutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
  background-color: whitesmoke;
}

.addbutton:hover {
  background-color: lightgray;
}

.notebutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
}

.notebutton:hover {
  background-color: whitesmoke;
}

.notebox {
  
  margin-left:-10px;
  margin-right:-10px
}

.active {
  background: green;
  border: 1px dotted blue;
  display:inline;
}

.sli:hover + .deletebutton {
  display: block
}

.deletebutton {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:40px;
    height:100%;
    margin-left: 5px;
    /* display:none; */
    /* border:1px solid gray; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (min-width: 500px) {

    .list {
      background-color: white;
      border-radius: 15px;
      padding: 50px;
      margin: 15px
    }

    .notebox {
      margin-left: 0px
    }
}

</style>